/* eslint no-console: 0 */
/* global axios */
import ApiClient from '../ApiClient';

export const buildCreatePayload = ({
  message,
  isPrivate,
  contentAttributes,
  echoId,
  cannedResponseId = null,
  files,
  ccEmails = '',
  bccEmails = '',
  toEmails = '',
  templateParams,
  inboxSignature = false,
}) => {
  let payload;
  if (files && files.length !== 0) {
    payload = new FormData();
    if (message) {
      payload.append('content', message);
    }
    files.forEach(file => {
      payload.append('attachments[]', file);
    });
    payload.append('private', isPrivate);
    payload.append('echo_id', echoId);
    payload.append('cc_emails', ccEmails);
    payload.append('bcc_emails', bccEmails);
    payload.append('inbox_signature', inboxSignature);

    if (cannedResponseId) {
      payload.append('related_id', cannedResponseId);
      payload.append('related_type', 'CannedResponse');
    }
    if (toEmails) {
      payload.append('to_emails', toEmails);
    }
    if (contentAttributes) {
      payload.append('content_attributes', JSON.stringify(contentAttributes));
    }
  } else {
    payload = {
      content: message,
      private: isPrivate,
      echo_id: echoId,
      content_attributes: contentAttributes,
      cc_emails: ccEmails,
      bcc_emails: bccEmails,
      to_emails: toEmails,
      inbox_signature: inboxSignature,
      template_params: templateParams,
    };
    if (cannedResponseId) {
      payload.related_id = cannedResponseId;
      payload.related_type = 'CannedResponse';
    }
  }
  return payload;
};

class MessageApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({
    conversationId,
    message,
    private: isPrivate,
    contentAttributes,
    echo_id: echoId,
    cannedResponseId,
    files,
    ccEmails = '',
    bccEmails = '',
    toEmails = '',
    templateParams,
    inboxSignature = false,
  }) {
    return axios({
      method: 'post',
      url: `${this.url}/${conversationId}/messages`,
      data: buildCreatePayload({
        message,
        isPrivate,
        contentAttributes,
        echoId,
        cannedResponseId,
        files,
        ccEmails,
        bccEmails,
        toEmails,
        templateParams,
        inboxSignature,
      }),
    });
  }

  updateContentAttributes({ conversationId, messageId, data }) {
    return axios.patch(
      `${this.url}/${conversationId}/messages/${messageId}/content_attributes`,
      { data: data }
    );
  }

  updateAdditionalAttributes({ conversationId, messageId, data }) {
    return axios.patch(
      `${this.url}/${conversationId}/messages/${messageId}/additional_attributes`,
      { data: data }
    );
  }

  delete(conversationID, messageId) {
    return axios.delete(`${this.url}/${conversationID}/messages/${messageId}`);
  }

  retry(conversationID, messageId) {
    return axios.post(
      `${this.url}/${conversationID}/messages/${messageId}/retry`
    );
  }

  getPreviousMessages({ conversationId, after, before }) {
    const params = { before };
    if (after && Number(after) !== Number(before)) {
      params.after = after;
    }
    return axios.get(`${this.url}/${conversationId}/messages`, { params });
  }

  translateMessage(conversationId, messageId, targetLanguage) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/translate`,
      {
        target_language: targetLanguage,
      }
    );
  }

  hideMessage(conversationId, messageId) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/hide`
    );
  }

  autoReplyMessage(conversationId, messageId) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/auto_reply`
    );
  }

  blockUser(conversationId, messageId) {
    return axios.post(
      `${this.url}/${conversationId}/messages/${messageId}/block_user`
    );
  }
}

export default new MessageApi();
